import settings from "./settings";

/**
 * @returns {Promise<import("src/types").Restaurant[]>}
 * */
export async function fetchRestaurants() {
  try {
    const url = DEV
      ? "/restaurants.json"
      : `${settings.wpApiHost}/wp-json/moxies/v1/restaurants`;
    const req = await fetch(url);

    if (req.ok) {
      const json = await req.json();
      return json;
    }
    throw req.statusText;
  } catch (err) {
    throw new Error(err);
  }
}
